/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_With_Ai_SendInputs */



/**
* | output |
* | --- |
* | "Send edit request" |
*
* @param {Artifact_Edit_With_Ai_SendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_with_ai_send = /** @type {((inputs?: Artifact_Edit_With_Ai_SendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_With_Ai_SendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungswunsch senden")
	return /** @type {LocalizedString} */ ("Send edit request")
});